import _ from "lodash";

export const getMainSubOrder = order => {
    if (!order || !order.sub_orders) {
        return null;
    }

    return (
        order.sub_orders.find(
            subOrder => !subOrder.order_statuses.some(status => (status.status === "CANCELLED" || status.status === "REFUNDED") && status.date)
        ) || null
    );
};

export const subOrderIsCancelled = sub_order => {
    return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "CANCELLED" && os.date);
};

export const orderIsCancelled = order => {
    return order.cancelled_at !== null;
};

export const orderIsFullyRefunded = order => {
    return order.fully_refunded !== null && order.fully_refunded;
};

export const subOrderIsShipped = sub_order => {
    return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "SHIPPED" && os.date);
};

export const subOrderIsRefunded = sub_order => {
    return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "REFUNDED" && os.date);
};

export const subOrderIsCompleted = sub_order => {
    return !sub_order.order_statuses.some(os => os.show === true && os.date === null);
};

export const getCompleteOrderStatus = order => {
    if (order.sub_orders.every(so => so.order_statuses.some(os => os.status === "REFUNDED" && os.date && os.show))) {
        return "Refunded";
    } else if (order.sub_orders.every(so => so.order_statuses.some(os => os.status === "DELIVERED" && os.date && os.show))) {
        return "Delivered";
    }
    return null;
};

export const isCurrentStatus = (order_status, order_statuses) => {
    return (
        order_status.show &&
        order_statuses.some(os => !os.date && os.show) &&
        order_statuses.filter(os => !os.date && os.show)[0].status === order_status.status
    );
};

export const isNextStatus = (order_status, order_statuses) => {
    return (
        order_statuses.filter(os => os.show).indexOf(order_status) > 1 &&
        isCurrentStatus(order_statuses[order_statuses.filter(os => os.show).indexOf(order_status) - 1], order_statuses)
    );
};

export const isLastStatus = (order_status, order_statuses) => {
    return order_statuses.filter(os => os.show).indexOf(order_status) === order_statuses.filter(os => os.show).length - 1;
};

export const isSecondLastStatus = (order_status, order_statuses) => {
    return order_statuses.filter(os => os.show).indexOf(order_status) === order_statuses.filter(os => os.show).length - 2;
};

export const isPreviousStatus = (order_status, order_statuses) => {
    return (
        isCurrentStatus(order_statuses[order_statuses.filter(os => os.show).indexOf(order_status) + 2], order_statuses) ||
        (order_statuses.every(os => os.show && os.date) &&
            order_statuses.filter(os => os.show)[0].indexOf(order_status) === order_statuses.filter(os => os.show).length - 2)
    );
};

export const isClosedStatus = (order_status, order_statuses) => {
    if (order_statuses.some(os => isCurrentStatus(os, order_statuses))) {
        var current_index = order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => isCurrentStatus(os, order_statuses))[0]);

        if (
            (!isSecondLastStatus(order_status, order_statuses) &&
                order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os.show).filter(os => os === order_status)[0]) < current_index) ||
            order_statuses.some(
                os =>
                    order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os.show).filter(oss => oss === order_status)[0]) >
                    current_index + 1
            )
        ) {
            return true;
        }
    } else {
        if (
            order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os === order_status)[0]) <
            order_statuses.filter(os => os.show).length - 2
        ) {
            return true;
        }
    }

    return false;
};

export const getCurrentSubOrderStatus = sub_order => {
    var current_status = sub_order.order_statuses.filter(order_status => isCurrentStatus(order_status, sub_order.order_statuses))[0];

    return current_status;
};

export const getSubOrderItems = (sub_order, order) => {
    var sub_order_line_items = [];

    if (order.refunded_items) {
        sub_order.line_items.forEach(line_item => {
            if (order.refunded_items.filter(ri => ri.id === line_item.id)[0]) {
                var refunded_item = order.refunded_items.filter(ri => ri.id === line_item.id)[0];

                if (line_item.quantity > 1 && line_item.quantity > refunded_item.quantity) {
                    let temp_line_item = JSON.parse(JSON.stringify(line_item));
                    temp_line_item.quantity = line_item.quantity - refunded_item.quantity;
                    sub_order_line_items.push(temp_line_item);
                }
            } else {
                sub_order_line_items.push(line_item);
            }
        });
    } else {
        sub_order_line_items = sub_order.line_items;
    }

    return sub_order_line_items;
};

export const getProtectionItems = order => {
    if (order && order.line_items) {
        return _.orderBy(
            order.line_items.filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD")),
            ["price"],
            ["desc"]
        );
    } else {
        return [];
    }
};

export const getItemsThatRequireShipping = order => {
    if (order && order.line_items) {
        return _.orderBy(
            order.line_items.filter(li => li.requires_shipping === true),
            ["price"],
            ["desc"]
        );
    } else {
        return [];
    }
};

export const getCalculatedProtectionItems = order => {
    var protectionLineItems = [];

    if (order && order.line_items) {
        if (order.refunded_items) {
            order.line_items
                .filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD"))
                .forEach(line_item => {
                    if (order.refunded_items.filter(ri => ri.id === line_item.id)[0]) {
                        var refunded_item = order.refunded_items.filter(ri => ri.id === line_item.id)[0];

                        if (line_item.quantity > 1 && line_item.quantity > refunded_item.quantity) {
                            let temp_line_item = JSON.parse(JSON.stringify(line_item));
                            temp_line_item.quantity = line_item.quantity - refunded_item.quantity;
                            protectionLineItems.push(temp_line_item);
                        }
                    } else {
                        protectionLineItems.push(line_item);
                    }
                });
        } else {
            protectionLineItems = order.line_items.filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD"));
        }
    }

    return _.orderBy(protectionLineItems, ["price"], ["desc"]);
};

export const sortItems = items => {
    let sortedItems = [];

    let itemsCopy = JSON.parse(JSON.stringify(items));

    itemsCopy.forEach(item => {
        item.price = parseFloat(item.price);
    });

    itemsCopy = _.orderBy(itemsCopy, ["price", "sku"], ["desc", "asc"]);

    itemsCopy.forEach(item => {
        if (item.requires_shipping === true) {
            sortedItems.push(item);

            let protectionItems = itemsCopy.filter(
                i => i.title.includes("Protection") && i.properties.some(p => p.name === "Reference" && p.value === item.variant_id.toString())
            );

            if (protectionItems) {
                sortedItems = sortedItems.concat(protectionItems);
            }
        }
    });

    let protectionItemsNotAllocated = itemsCopy.filter(
        i => i.title.includes("Protection") && !i.sku.includes("EGIFTCARD") && !sortedItems.some(sortedItem => sortedItem.id == i.id)
    );

    if (protectionItemsNotAllocated && protectionItemsNotAllocated.length > 0) {
        sortedItems = sortedItems.concat(protectionItemsNotAllocated);
    }

    return sortedItems;
};

export const sortModifiedItems = (items, order) => {
    let normalSortedList = sortItems(order.line_items);
    let sortedItems = [];
    let itemsCopy = JSON.parse(JSON.stringify(items));
    itemsCopy.forEach(item => {
        item.price = parseFloat(item.price);
    });

    normalSortedList.forEach(normalSorteditem => {
        var item = items.filter(i => i.id === normalSorteditem.id)[0];
        if (item) {
            sortedItems.push(item);
        }
    });

    return sortedItems;
};

export const getRefundedItems = order => {
    return order.refunded_items;
};

export const getSubOrders = order => {
    return order && order.sub_orders;
};

export const getVisibleSubOrders = order => {
    let sub_orders = getSubOrders();

    if (sub_orders) {
        sub_orders = sub_orders.filter(sub_order => this.getSubOrderItems(sub_order, order).length > 0);
    }

    return sub_orders;
};

export const orderUtils = {
    getMainSubOrder,
    subOrderIsCancelled,
    orderIsCancelled,
    orderIsFullyRefunded,
    subOrderIsShipped,
    subOrderIsRefunded,
    subOrderIsCompleted,
    getCompleteOrderStatus,
    isCurrentStatus,
    isNextStatus,
    isLastStatus,
    isSecondLastStatus,
    isPreviousStatus,
    isClosedStatus,
    getCurrentSubOrderStatus,
    getSubOrderItems,
    getProtectionItems,
    getItemsThatRequireShipping,
    getCalculatedProtectionItems,
    sortItems,
    sortModifiedItems,
    getRefundedItems,
    getVisibleSubOrders
};



// WEBPACK FOOTER //
// ./src/views/Order/Helpers/OderUtils.js